import * as React from "react";
import ParagraphSup from "../../common/atom/text/paragraph_sup";
import {
  AuthWrapper,
  CreateFormFlex,
  CreateFormWrapper,
} from "./share/auth_share_components";
import AuthSuperEngineerCreateForm from "./super_engineer_create/auth_super_engineer_create_form";
import AuthSuperEngineerCreateSide from "./super_engineer_create/auth_super_engineer_create_side";

interface IProps {
  handleCallCreate: (values: any) => void;
}

const AuthSuperEngineerCreateComponent: React.FC<IProps> = (props) => {
  const { handleCallCreate } = props;

  return (
    <React.Fragment>
      <AuthWrapper>
        <CreateFormWrapper>
          <CreateFormFlex>
            <AuthSuperEngineerCreateSide />
            <AuthSuperEngineerCreateForm onSubmit={handleCallCreate} />
          </CreateFormFlex>
          <ParagraphSup>© 2022 Libera Inc.</ParagraphSup>
        </CreateFormWrapper>
      </AuthWrapper>
    </React.Fragment>
  );
};

export default AuthSuperEngineerCreateComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/auth/auth_super_enginner_create.tsx